
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-07-06-r3f-video-textures",
      function () {
        return require("private-next-pages/blogs/2025-07-06-r3f-video-textures/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-07-06-r3f-video-textures"])
      });
    }
  